/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
import * as Types from "../../../../__graphql__/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetSuppliersForHubQueryVariables = Exact<{ [key: string]: never }>;

export type GetSuppliersForHubQuery = {
  getSuppliersForHub: {
    suppliers: Array<{ id: string; name: string; sortSequence: number; externalId: string }>;
  };
};

export const GetSuppliersForHubDocument = gql`
  query getSuppliersForHub {
    getSuppliersForHub {
      suppliers {
        id
        name
        sortSequence
        externalId
      }
    }
  }
`;

/**
 * __useGetSuppliersForHubQuery__
 *
 * To run a query within a React component, call `useGetSuppliersForHubQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSuppliersForHubQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSuppliersForHubQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSuppliersForHubQuery(
  baseOptions?: Apollo.QueryHookOptions<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>(
    GetSuppliersForHubDocument,
    options,
  );
}
export function useGetSuppliersForHubLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetSuppliersForHubQuery,
    GetSuppliersForHubQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>(
    GetSuppliersForHubDocument,
    options,
  );
}
// @ts-ignore
export function useGetSuppliersForHubSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetSuppliersForHubQuery,
    GetSuppliersForHubQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>;
export function useGetSuppliersForHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>,
): Apollo.UseSuspenseQueryResult<
  GetSuppliersForHubQuery | undefined,
  GetSuppliersForHubQueryVariables
>;
export function useGetSuppliersForHubSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSuppliersForHubQuery, GetSuppliersForHubQueryVariables>(
    GetSuppliersForHubDocument,
    options,
  );
}
export type GetSuppliersForHubQueryHookResult = ReturnType<typeof useGetSuppliersForHubQuery>;
export type GetSuppliersForHubLazyQueryHookResult = ReturnType<
  typeof useGetSuppliersForHubLazyQuery
>;
export type GetSuppliersForHubSuspenseQueryHookResult = ReturnType<
  typeof useGetSuppliersForHubSuspenseQuery
>;
export type GetSuppliersForHubQueryResult = Apollo.QueryResult<
  GetSuppliersForHubQuery,
  GetSuppliersForHubQueryVariables
>;
